module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Black.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Black.ttf
// module id = 67
// module chunks = 8